import dayjs from 'dayjs';
import { CompareQueryProperty } from '../store/types';

export const getDefaultCompareToCustomAbsoluteDuration = (
  timezone: string,
): Required<Pick<CompareQueryProperty, 'timerange'>> & CompareQueryProperty => {
  return {
    timerange: {
      startAfter: dayjs().tz().subtract(1, 'month').unix() * 1000,
      endBefore: dayjs().tz().unix() * 1000,
    },
  };
};
